import Layout from '../components/Layout';
import Contact from '../components/Contact';

export default () => (
  <Layout>
    <div className="container">
      <h2 className="mb-30">About</h2>
      <div className="text-justify">
        <p>
          Matlogica specializes in software solutions that allow to accelerate Monte-Carlo Simulations using highly parallel vectorized software and automatic adjoint differentiation. At the moment we are developing a breakthrough C++ tool for AAD. Our unique approach allowed us to obtain impressive benchmarks compared to other well known AAD tools. If you are interested in getting the best performance from your existing or new C++ library, we can offer quick proof-of-concept projects to gage the possible benefits our tool can bring to you.
        </p>
        <p>
          Matlogica brings together a broad range of specialists: from quantitative analysts and computer science engineers to academic researchers. The company was organized around an invention which forms the kernel of the new Adjoint Differentiation Tool.
        </p>
        <p>
          We specialize in parallel computations in a wide range of areas including XVA, MVA, Monte-Carlo Simulations, Derivative pricing and Risk, Large Portfolio simulations, Model calibrations such as Heston SV and LMM, among others.
        </p>
      </div>
      <Contact/>
    </div>
  </Layout>
)